module.exports = __webpack_public_path__ + "static/cover2-6342c557182ad76333ee69f38c4f390b.png";